"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASSIFIER_NAME_ALPHABET = exports.CLASSIFIER_NAME_ID_LENGTH = void 0;
exports.CLASSIFIER_NAME_ID_LENGTH = 10;
exports.CLASSIFIER_NAME_ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';
//# sourceMappingURL=classifier.js.map